<template>
  <modal
      :draggable="true"
      :resizable="true"
      :clickToClose="false"
      :name=modalName
      :min-width="425"
      width="70%"
      :min-height="(height / 2)"
      :height="height"
      :scrollable="true"
      @opened="modalOpened"
      class="modalBox"
      :style="{'--selectHeight': selectHeight}"
  >
    <div class="window-header">
      {{ itemTitle }}
      <a href="javascript:void(0)" class="close-modal pull-right" @click="closeModal">
        <i class="fa fa-times"></i>
      </a>
    </div>
    <div class="modal-body" ref="modalBox">
      <div class="page-modal" style="background:white">
        <div class="alert alert-danger alert-dismissable" v-show="error !== ''">
          <strong>Error </strong>
          <div class="errorMsg" style="display: inline-block;">{{ error }}</div>
        </div>
        <form ref="form" class="form-horizontal" @submit.prevent="submitForm">
          <template v-for="(field, index) in formData">
            <div class="row mt-2"
                 v-if="formData[index].show && ([].concat(formData[index].form).includes(action) || formData[index].form === undefined)"
                 v-bind:key="index">
              <label v-if="formData[index].help" class="col-sm-2 col-form-label">
                {{ (field.label !== undefined) ? field.label : field.name }} <span class="text-danger" v-if="formData[index].required">*</span>
              </label>
              <label v-else class="col-sm-2 col-form-label">{{ (field.label !== undefined) ? field.label : field.name }} <span class="text-danger"
                                                                                                                 v-if="formData[index].required">*</span></label>
              <div class="col-sm-10">
                <p class="help-text m-0" v-if="formData[index].help"><i class="fa fa-info-circle"></i>
                  {{ formData[index].help }}</p>
                <input
                    @blur="validate(index, formData[index].value, formData[index].rule)"
                    :type="formData[index].type"
                    class="form-control"
                    placeholder="N/A"
                    :required="formData[index].required ?? false"
                    v-model="formData[index].value"
                    v-if="formData[index].show && ['text', 'number', 'email'].includes(formData[index].type)"
                    :disabled="field.name === 'Id'"
                    v-bind:class="formData[index].class">

                <v-select v-if="formData[index].type === 'select_native'"
                          :options="formData[index].options"
                          :items="formData[index].options"
                          label="text"
                          @input="updateSelectValue($event, index, formData[index].value)"
                          :value="formData[index].value"
                          v-model="formData[index].value"
                          :active="true"
                          :required="formData[index].required ?? false"
                          maxHeight="50px"
                          placeholder="N/A"
                          inputId="value"/>
                <b-form-select v-if="formData[index].type === 'select'"
                               :options="formData[index].options"
                               label="text"
                               @input="updateSelectValue($event, index, formData[index].value)"
                               v-model="formData[index].value"
                               clearable
                               :required="formData[index].required ?? false"
                               maxHeight="50px"
                               placeholder="N/A"
                               inputId="value"/>

                <b-form-datepicker v-if="formData[index].type === 'datex'"
                          class="mb-2 date-form-item"
                          placeholder="YYYY-MM-DD"
                          type="text"
                          today-button
                          reset-button
                          close-button
                          :start-weekday="monday"
                          locale="en-US"
                          v-model="formData[index].value"
                          :required="formData[index].required ?? false"
                          inputId="value"/>

                <b-input-group class="mb-3" v-if="formData[index].type === 'date'">
                  <b-form-input
                      id="example-input"
                      v-model="formData[index].value"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                      :required="formData[index].required ?? false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                        class="mb-2 date-form-item"
                        v-model="formData[index].value"
                        button-only
                        right
                        locale="en-US"
                        aria-controls="example-input"
                        @context="onContext"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>

                <b-form-textarea
                    :class="'form-control' + formData[index].class"
                    :rows="formData[index].rows || 5"
                    :required="formData[index].required ?? false"
                    placeholder="N/A"
                    v-if="formData[index].type === 'textarea'"
                    v-model="formData[index].value"></b-form-textarea>
                <v-jsoneditor
                    v-if="formData[index].type === 'json'"
                    v-model="jsonData[index]"
                    placeholder="N/A"
                    :required="formData[index].required ?? false"
                    :plus="false"
                    :options="jsonOptions"
                    :height="'400px'"></v-jsoneditor>
                <div
                    class="search-select-container"
                    v-if="formData[index].type === 'search-select'">
                  <model-select
                      :options="formData[index].options"
                      v-model="formData[index].value"
                      placeholder="select item">
                  </model-select>

                </div>
                <!--                <button-->
                <!--                    type="button"-->
                <!--                    v-if="formData[index].type === 'textarea' && formData[index].name !== 'Import'"-->
                <!--                    class="btn btn-default col-sm-1"-->
                <!--                    @click="showTextareaData()"-->
                <!--                >Open-->
                <!--                </button>-->
              </div>
            </div>
          </template>
          <div v-show="loaded" class="row">
            <div class="col-sm-4 mt-2"><p v-if="issetRequired" class="text-danger">* Required fields</p></div>
            <div class="col-sm-8 mt-2" style="text-align:right">
              <button type="button" @click="closeModal" class="btn btn-danger text-white mr-2">Cancel
              </button>
              <button type="submit" class="btn btn-primary">{{ actionText }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ModalLog :data="textareaData" :modalName="'itemTextarea'" @close="closeModal"/>
  </modal>
</template>

<script>
import axios from 'axios';
import VJsoneditor from 'v-jsoneditor/src/index';
import ModalLog from "./ModalLog";
import {ModelSelect} from 'vue-search-select';
import _ from "lodash"
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'newItem',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    VJsoneditor,
    ModalLog,
    ModelSelect,
  },
  props: {
    type: String,
    withLocalData: Boolean,
    localData: Object,
    itemId: Number,
    modalName: String,
    item: Object,
    title: String,
    updateTitleKey: String,
    height: {
      type: Number,
      default: 270
    }
  },
  computed: {
    issetRequired: function () {
      return _.find(this.formData, {required: true})
    },
    itemTitle: function () {
      if (!this.title) {
        if (this.type === 'create') {
          return 'New item';
        } else {
          return 'Edit item ' + this.itemId;
        }
      } else {
        if (this.updateTitleKey) {
          console.log(this.title, this.updateTitleKey)
          return this.title + this.item[this.updateTitleKey]
        } else {
          return this.title
        }
      }
    }
  },
  data() {
    return {
      error: '',
      actionText: '...',
      action: 'add',
      apiUrl: '',
      redirectToUrl: '',
      helperApiUrl: '',
      apiConfig: '/api/config/item-form/',
      login: '/login',
      loading: 'loaded',
      formData: {},
      invalidClass: 'invalidated',
      jsonOptions: {
        "modes": ["tree", "code", "text"]
      },
      jsonData: {},
      textareaData: '',
      selectHeight: '120px',
      loaded: false,
      startLoaded: false,
      loader: null
    }
  },
  methods: {
    closeModal() {
      this.formData = {}
      this.loaded = false
      this.startLoaded = false
      this.$modal.hide(this.modalName)
    },
    updateSelectValue($event, index, oldValue) {
      console.log("updateSelectValue start", this.formData)
      if ($event === null || $event === undefined) {
        return
      }
      console.log("updateSelectValue", index, oldValue, $event, this.formData[index].value, this.formData[index])
      if (this.formData[index].name === "Type") {
        if ($event.value === undefined) {
          this.formData[index].value = parseInt($event)
        } else {
          this.formData[index].value = parseInt($event.value)
        }
      } else {
        if ($event.value === undefined) {
          this.formData[index].value = $event
        } else {
          this.formData[index].value = $event.value
        }
      }
      console.log("updateSelectValue end", this.formData)
    },
    getValueForSelect(index) {
      const value = this.formData[index].value
      console.log("getValueForSelect", value, index, this.formData[index])
      if (!value && this.formData[index].name !== "Type") {
        console.log("getValueForSelect xxx", value, index, this.formData[index])
        return
      }
      if (this.formData[index].name === "Type") {
        return this.formData[index].options.find(x => parseInt(x.value) === value)
      }
      return this.formData[index].options.find(x => x.value === value)
    },
    reset() {
      this.item = {}
    },
    selectFromParentComponent1() {
      // select option from parent component
      this.item = this.options[0]
    },
    returnBackToList() {
      this.$router.go(-1);
    },
    LoadConfig() {
      this.startLoaded = true
      console.log('LoadConfig', this.type, this.withLocalData);
      // this.loader = this.$loading.show();
      this.filter = [];
      this.items = null;
      this.error = '';
      this.loading = 'loading';
      let pageName = this.$route.params.page;
      if (!pageName) {
        pageName = this.$route.name;
      }
      if (this.withLocalData) {
        this.formData = this.localData.formData
        console.log('localData');
        this.apiUrl = this.localData.apiUrl;
        this.redirectToUrl = this.localData.redirectToUrl;
        if (this.localData.helperApiUrl !== undefined) {
          this.helperApiUrl = this.localData.helperApiUrl;
        }
        console.log(this.localData);
        this.loaded = true;
        this.configureFields();
      } else {
        axios.get(this.apiConfig + pageName, this.authRespConf())
            .catch((err) => {
              if (this.loader) {
                this.loader.hide();
              }
              this.loading = 'loaded';
              this.errorHandle(err, true, true);
            })
            .then(res => {
              if (this.loader) {
                this.loader.hide();
              }
              this.loading = 'loaded';
              this.loaded = true
              //console.log('loaded config');
              this.apiUrl = res.data.apiUrl;
              this.redirectToUrl = res.data.redirectToUrl;
              if (res.data.helperApiUrl !== undefined) {
                this.helperApiUrl = res.data.helperApiUrl;
              }
              this.formData = res.data.formData;
              //console.log('title', this.title);
              //console.log('title', res.data.title);
              //console.log('filterValues', res.data.filterValues);
              this.configureFields();
            });
      }
      //console.log('after load config func');
    },
    validate(field, val, rule) {
      if (rule === undefined ||
          rule === null ||
          rule === '' ||
          (this.formData[field].required !== true && val == '')
      ) {
        this.formData[field].class = '';
        return
      }
      let re = new RegExp(rule, "i");
      if (!re.test(val)) {
        console.log('INVALID');
        this.formData[field].class = this.invalidClass;
      } else {
        this.formData[field].class = '';
      }
      console.log(field, val, rule, this.formData);
      if (this.helperApiUrl !== '') {
        console.log(this.helperApiUrl);
        this.getValidData();
      }
    },
    moveUp() {
      window.scrollTo(0, 0);
    },
    trimText(text) {
      const pattern = /\n[\s]+/gi;
      const replacement = "\n";
      return text.replace(pattern, replacement).trim();
    },
    submitForm() {
      let loader = this.$loading.show();
      this.error = '';
      let data = {};
      for (let realFieldName in this.formData) {
        if (this.formData[realFieldName].class === this.invalidClass) {
          this.error = 'invalid format for field: ' + this.formData[realFieldName].name;
          this.moveUp();
          return;
        }
        data[realFieldName] = this.formData[realFieldName].value
        if (this.formData[realFieldName].type === 'number' || this.formData[realFieldName].toType === 'number') {
          data[realFieldName] = parseInt(this.formData[realFieldName].value)
        }
        if (this.formData[realFieldName].type === 'select') {
          data[realFieldName] = this.formData[realFieldName].value
        }
        if (this.formData[realFieldName].type === 'json') {
          data[realFieldName] = JSON.stringify(this.jsonData[realFieldName]);
        }
        if (this.formData[realFieldName].type === 'textarea') {
          data[realFieldName] = this.trimText(this.formData[realFieldName].value)

        }

      }
      let itemId = parseInt(this.itemId);
      if (itemId > 0) {
        data['id'] = itemId;
      }
      if (this.action == 'add') {
        data['id'] = null;
        axios.post(this.apiUrl, data, this.authRespConf())
            .then(res => {
              loader.hide();
              if (res !== null && res !== undefined) {
                if (res.data.message !== null && res.data.message !== undefined) {
                  this.notifyData = res.data.message;
                  this.textareaData = res.data.message;
                  console.log(res.data.message);
                  this.showNotifyData();
                } else {
                  this.$emit('onSuccess');
                }
              } else {
                this.$emit('onSuccess');
              }
            })
            .catch((err) => {
              loader.hide();
              this.moveUp();
              this.errorHandle(err, true, true);
            });
      } else {
        axios.patch(this.apiUrl, data, this.authRespConf())
            .then(() => {
              loader.hide();
              this.$emit('onSuccess');
            })
            .catch((err) => {
              loader.hide();
              this.errorHandle(err, true, true);
            });
      }
    },
    configureFieldsWorker(itemData, custom = []) {
      console.log('configureFieldsWorker', this.formData, itemData);
      this.action = 'update';
      for (let field in itemData) {
        if (this.formData[field] != undefined) {
          if (field == 'Id') {
            this.formData[field].type = 'number';
            this.formData[field].show = true;
          }
          if (this.formData[field].type === 'json') {
            this.jsonData[field] = JSON.parse(itemData[field]);
          }
          //console.log("configureFieldsWorker set", field, itemData[field], itemData)
          this.formData[field].value = itemData[field];
          //console.log("configureFieldsWorker set", field, this.formData[field].value)
        }
      }
      if (Object.keys(this.formData).length === 0) {
        return;
      }
      for (let field in this.formData) {
        if ((this.formData[field].type === 'select' || this.formData[field].type === 'search-select') &&
            (this.formData[field].url !== '' && this.formData[field].url !== undefined)) {
          console.log("options set to 0", field, this.formData[field].url)
          this.formData[field].options = [];
          let request
          if (this.formData[field].method && this.formData[field].method === 'get') {
            request = axios.get(this.formData[field].url, this.authRespConf())
          } else {
            request = axios.post(this.formData[field].url, [], this.authRespConf())
          }

          request.catch((err) => {
            this.errorHandle(err);
          }).then(res => {
            let indexField;
            if (res.data.data !== undefined) {
              this.formData[field].options.push(
                  {
                    value: "",
                    label: "",
                    title: "",
                    text: ""
                  }
              );
              _.forEach(res.data.data, (value, key) => {
                indexField = this.formData[field].indexField ?? "Id";
                if (field === 'Entity') {
                  this.formData[field].options.push(
                      {
                        value: key,
                        title: value,
                        label: value,
                        text: value
                      }
                  );
                } else {
                  this.formData[field].options.push(
                      {
                        value: value[indexField],
                        title: value[this.formData[field].field],
                        label: value[this.formData[field].field],
                        text: value[this.formData[field].field]
                      }
                  );
                }
              })

            }
            if (this.formData[field].type !== 'search-select' && itemData) {
              let optionIncluded = false;
              for (let optionIndex in this.formData[field].options) {
                if (this.formData[field].options[optionIndex].Value == itemData[field]) {
                  optionIncluded = true;
                }
              }
              if (!optionIncluded && itemData !== null && field !== "Entity") {
                let dataText = this.item[this.formData[field].fieldItem];
                if (field === 'IpId') {
                  dataText = custom['ip']['Address']
                }
                if (!dataText) {
                  dataText = 'val = ' + itemData[field];
                }
                this.formData[field].options.push(
                    {
                      value: itemData[field],
                      text: dataText
                    }
                )
              }
            }
          })
        }
      }
      console.log("configureFieldsWorker end", this.formData)
    },
    configureFields() {
      let entityId = parseInt(this.itemId);
      if (entityId < 0) {
        return
      }
      let formType = this.type;
      if (entityId === 0 && formType !== 'create') {
        return
      }
      if (formType !== 'create') {
        let loader = this.$loading.show();
        this.actionText = 'Update';
        axios.get(this.apiUrl + entityId, this.authRespConf())
            .then(res => {
              loader.hide();
              if (res.data != '') {
                this.configureFieldsWorker(res.data.data, res.data.custom ?? []);
              }
            })
            .catch((err) => {
              loader.hide();
              this.errorHandle(err);
            });
      } else {
        this.configureFieldsWorker(null);
      }
      if (formType === 'create') {
        this.actionText = 'Create';
        this.action = 'add';
      }
    },
    getValidData() {
      let loader = this.$loading.show();
      this.error = '';
      let data = {};
      for (let realFieldName in this.formData) {
        if (this.formData[realFieldName].class === this.invalidClass) {
          this.error = 'invalid format for field: ' + this.formData[realFieldName].name;
          this.moveUp();
          return;
        }
        data[realFieldName] = this.formData[realFieldName].value;
        if (this.formData[realFieldName].type === 'number' || this.formData[realFieldName].toType === 'number') {
          data[realFieldName] = parseInt(this.formData[realFieldName].value)
        }
        if (this.formData[realFieldName].type === 'json') {
          data[realFieldName] = JSON.stringify(this.jsonData[realFieldName]);
        }
      }
      let itemId = parseInt(this.itemId);
      if (itemId > 0) {
        data['Id'] = itemId;
      }
      if (this.helperApiUrl !== '') {
        axios.post(this.helperApiUrl, data, this.authRespConf())
            .then(res => {
              loader.hide();
              if (res !== null && res !== undefined) {
                if (res.data !== null && res.data !== undefined) {
                  for (let fieldName in res.data) {
                    if (this.formData[fieldName] !== undefined) {
                      if (res.data[fieldName] != '') {
                        this.formData[fieldName].value = res.data[fieldName];
                      }
                    }
                  }
                }
              }
            })
            .catch((err) => {
              loader.hide();
              this.moveUp();
              this.errorHandle(err, true, true);
            });
      }
    },
    onChangeJson() {
      console.log('onChange json');
    },
    showTextareaData() {
      this.textareaData = this.getTextFieldData();
      this.$modal.show('itemTextarea');
    },
    showNotifyData() {
      this.$modal.show('itemTextarea');
    },
    getTextFieldData() {
      for (let field in this.formData) {
        if (this.formData[field].type === 'textarea') {
          return this.formData[field].value;
        }
      }
    },
    modalOpened() {
      if (this.loaded || this.startLoaded) return;
      console.log('modalOpened', this.loaded);
      this.loader = this.$loading.show()
      this.LoadConfig();
      if (this.action == 'add') {
        this.loader.hide();
        if (this.formData['id'] != undefined) {
          this.formData['id'].value = null;
        }
        if (this.formData['Id'] != undefined) {
          this.formData['Id'].value = null;
        }
      }
      this.selectHeight = this.$refs.modalBox.clientHeight + 'px;'
    }
  },
  watch: {
    '$route': function (val) {
      console.log('modal watch $route', val, this.loaded);
      this.LoadConfig();
    },
    'itemId': function (val) {
      console.log('watch itemId', val, this.loaded);
      this.LoadConfig();
    }
  },

}
</script>
